import React from "react";
import { BmModal } from "../../../ForBrands/ui/BrandUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { TEAM_FACTORS } from "./teamModel";

// What each team style factor measures (Figma 02b · Modal · Team Archetype).
// py-1 on top of the modal body padding gives the frame's 24 / 28 px.
// Inside the phone theme BmModal opens as the bottom sheet (2410:1047):
// the rows sit 8px under the sheet header (-mt-2 on the sheet body's 16px),
// with 12px corners, a 60px code column and the text top-aligned.
const TeamArchetypeModal = ({ onClose }) => {
  const phone = usePhoneTheme();
  return (
    <BmModal title="Team Archetype" onClose={onClose} width={720}>
      <ul className={phone ? "-mt-2 flex flex-col gap-2" : "flex flex-col gap-2 py-1"}>
        {TEAM_FACTORS.map((f) => (
          <li
            key={f.code}
            className={
              phone
                ? "flex items-start gap-[14px] rounded-[12px] border border-bm-border bg-bm-subtle px-4 py-[14px]"
                : "flex items-center gap-4 rounded-[8px] border border-bm-border bg-bm-subtle px-5 py-4"
            }
          >
            <span className={phone ? "w-[60px] shrink-0 bm-label-l text-bm-orange" : "w-[72px] shrink-0 bm-label-l text-bm-orange"}>{f.code}</span>
            <span className="flex min-w-0 flex-col gap-1">
              <span className="bm-h-s text-bm-ink">{f.title}</span>
              <span className="bm-body-m text-bm-muted">{f.description}</span>
            </span>
          </li>
        ))}
      </ul>
    </BmModal>
  );
};

export default TeamArchetypeModal;
